module.exports = __webpack_public_path__ + "static/media/pause.98e994c8.svg";